import axios from "axios";

const apiClient = axios.create({
    baseURL: `${window.location.origin}/wp-json/mda/v2`,
});

class ApiService {
    getQuestions(page_id) {
        return apiClient
            .get(`/page/${page_id}/questions/`)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                return error;
            });
    }

    postQuestions(data) {
        return apiClient
            .post("/answers/submit", data)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                return error;
            });
    }

    startQuestionaire(data) {
        return apiClient.post("/started-questonaire", data);
    }
}

export default new ApiService();
